// daz.registerModal.open()
// or .js-open-register-modal with data attributes for options

if (!window.daz) {
    window.daz = {};
}

(function () {
    var MODAL_SELECTOR = '.register-modal[data-isModal]';
    var RECAPTCHA_SRC = 'https://www.google.com/recaptcha/api.js';
    var TRIGGER_SELECTOR = '.js-open-register-modal';
    var FRAGMENT_URL = '/customer/account/register-modal';
    var recaptchaRequested = false;
    var loadPromise = null;
    var closeHandlersBound = false;

    function getModal() {
        return document.querySelector(MODAL_SELECTOR);
    }

    function loadRecaptcha() {
        if (recaptchaRequested || window.grecaptcha) {
            return;
        }

        recaptchaRequested = true;

        var script = document.createElement('script');
        script.src = RECAPTCHA_SRC;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    function getOptionsFromElement(el) {
        var options = {};

        function setStringOption(key, attr) {
            var value = el.getAttribute(attr);
            if (value !== null && value !== '') {
                options[key] = value;
            }
        }

        setStringOption('useID', 'data-use-id');
        setStringOption('rpid', 'data-rpid');
        setStringOption('redirect', 'data-redirect');
        setStringOption('compat_softw_pref', 'data-compat-softw-pref');
        setStringOption('headerText', 'data-header-text');
        setStringOption('subheaderText', 'data-subheader-text');
        setStringOption('formText', 'data-form-text');
        setStringOption('preSubmitText', 'data-pre-submit-text');
        setStringOption('postSubmitText', 'data-post-submit-text');
        setStringOption('submitButtonText', 'data-submit-button-text');

        if (el.hasAttribute('data-skip-want-studio')) {
            var skipWantStudio = el.getAttribute('data-skip-want-studio');
            options.skipWantStudio = skipWantStudio === null
                || skipWantStudio === ''
                || skipWantStudio === 'true'
                || skipWantStudio === '1';
        }

        return options;
    }

    function buildFragmentUrl(options) {
        var url = new URL(FRAGMENT_URL, document.location.href);
        options = options || {};

        var stringParams = {
            useID: 'useID',
            rpid: 'rpid',
            redirect: 'redirect',
            compat_softw_pref: 'compat_softw_pref',
            headerText: 'headerText',
            subheaderText: 'subheaderText',
            formText: 'formText',
            preSubmitText: 'preSubmitText',
            postSubmitText: 'postSubmitText',
            submitButtonText: 'submitButtonText'
        };

        Object.keys(stringParams).forEach(function (key) {
            if (options[key]) {
                url.searchParams.set(stringParams[key], options[key]);
            }
        });

        if (options.skipWantStudio) {
            url.searchParams.set('skipWantStudio', '1');
        }

        return url.toString();
    }

    function initCloseHandlers(modal) {
        if (!modal || closeHandlersBound) {
            return;
        }
        closeHandlersBound = true;

        var closeBtn = modal.querySelector('.register__close');
        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.preventDefault();
                closeModal();
            });
        }

        modal.addEventListener('click', function (e) {
            if (e.target === modal) {
                closeModal();
            }
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && modal.classList.contains('register-modal--open')) {
                closeModal();
            }
        });
    }

    function makeModal(options) {
        var existing = getModal();
        if (existing) {
            return Promise.resolve(existing);
        }

        if (loadPromise) {
            return loadPromise;
        }

        loadPromise = fetch(buildFragmentUrl(options), {
            credentials: 'same-origin',
            headers: { 'Accept': 'text/html' }
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('Failed to load register modal');
            }
            return response.text();
        }).then(function (html) {
            document.body.insertAdjacentHTML('beforeend', html);

            var modal = getModal();
            if (!modal) {
                throw new Error('Register modal markup missing');
            }

            initCloseHandlers(modal);

            if (daz.initRegisterForms) {
                daz.initRegisterForms(modal);
            }

            return modal;
        }).catch(function (err) {
            loadPromise = null;
            throw err;
        });

        return loadPromise;
    }

    function showModal(modal) {
        loadRecaptcha();
        modal.classList.add('register-modal--open');
        modal.setAttribute('aria-hidden', 'false');

        var firstInput = modal.querySelector('input[name="firstname"]');
        if (firstInput) {
            window.setTimeout(function () {
                firstInput.focus();
            }, 0);
        }
    }

    function openModal(options) {
        return makeModal(options).then(function (modal) {
            showModal(modal);
            return modal;
        }).catch(function (err) {
            console.error(err);
        });
    }

    function closeModal() {
        var modal = getModal();
        if (!modal) {
            return;
        }

        modal.classList.remove('register-modal--open');
        modal.setAttribute('aria-hidden', 'true');
    }

    function initTriggers() {
        document.addEventListener('click', function (e) {
            var trigger = e.target.closest(TRIGGER_SELECTOR);
            if (!trigger) {
                return;
            }

            e.preventDefault();
            openModal(getOptionsFromElement(trigger));
        });
    }

    daz.registerModal = {
        open: openModal,
        close: closeModal,
        init: function () {
            initTriggers();
        }
    };

    $(document).ready(function () {
        daz.registerModal.init();
    });
})();
